import React, { lazy, Suspense } from "react";
import LazyLoader from "../../components/common/loader/lazyLoader";
const AddCategoryWiseB1G1Offers = lazy(() =>
  import("../../components/setOffers/categoryB1G1")
);

const CategoryB1G1Page = () => {
  return (
    <Suspense fallback={<LazyLoader />}>
      <AddCategoryWiseB1G1Offers />
    </Suspense>
  );
};

export default CategoryB1G1Page;
